import { CircularProgress } from "@mui/material";
import ToshowExercise from "./components/modalToshowExercise";
import ParameterModel from "./components/ParameterModel";
import ExerciseHistoryModel from "./components/ExerciseHistoryModel";
import ModalToShowAnExerciseInfo from "./components/ModalToShowAnExerciseInfo";
import CustomConfirmationOk from "src/components/ModalPopover/ConfirmationOk";

const ModalsManager = ({
  isLoading,
  classes,
  openPaceAlert,
  setOpenPaceAlert,
  openSingleExerciseInfo,
  setOpenSingleExerciseInfo,
  singleExerciseInfo,
  openDetails,
  setOpenDetails,
  handleSelectExercise,
  isExerciseForSuperSet,
  setIsExerciseForSuperSet,
  isWithHistory,
  handleSelectSupersetExerciseSingle,
  handleSelectSupersetExercise,
  modalOpen,
  setModalOpen,
  exerInfo,
  handleChangeParametersInset,
  addArray,
  historyModalOpen,
  setHistoryModalOpen,
  historyModalOpenSuperset,
  setHistoryModalOpenSuperset,
  historyModalData,
  setHistoryModalData,
  handleCopyExercise,
  handleCopySupersetExercise,
  reps_for_time,
}) => {
  return (
    <>
      {isLoading && (
        <CircularProgress className={classes.loading2} color="primary" />
      )}

      {openPaceAlert && (
        <CustomConfirmationOk
          open={openPaceAlert}
          setOpen={setOpenPaceAlert}
          title="Oops!"
          descriotion="This type & distance not suitable for that pace"
        />
      )}

      {openSingleExerciseInfo && (
        <ModalToShowAnExerciseInfo
          open={openSingleExerciseInfo}
          setOpen={setOpenSingleExerciseInfo}
          Id={singleExerciseInfo}
        />
      )}

      {openDetails && (
        <ToshowExercise
          open={openDetails}
          setOpen={setOpenDetails}
          handleChange={handleSelectExercise}
        />
      )}

      {isExerciseForSuperSet && (
        <ToshowExercise
          open={isExerciseForSuperSet}
          setOpen={setIsExerciseForSuperSet}
          handleChange={
            isWithHistory
              ? handleSelectSupersetExerciseSingle
              : handleSelectSupersetExercise
          }
          isWithHistory={isWithHistory}
        />
      )}

      {modalOpen && (
        <ParameterModel
          open={modalOpen}
          setOpen={setModalOpen}
          data={exerInfo}
          handleChange={handleChangeParametersInset}
          addArray={addArray}
          reps_for_time={reps_for_time}
        />
      )}

      {historyModalOpen && (
        <ExerciseHistoryModel
          open={historyModalOpen}
          setOpen={setHistoryModalOpen}
          data={historyModalData}
          handleChange={setHistoryModalData}
          handleCopyExercise={handleCopyExercise}
        />
      )}

      {historyModalOpenSuperset && (
        <ExerciseHistoryModel
          open={historyModalOpenSuperset}
          setOpen={setHistoryModalOpenSuperset}
          data={historyModalData}
          handleChange={setHistoryModalData}
          handleCopyExercise={handleCopySupersetExercise}
        />
      )}
    </>
  );
};

export default ModalsManager;
